import { createStore } from 'owa-satcheljs';
import type { EasidResponse } from 'owa-licensing-utils/lib/schema/EasidResponse';
import type { EasidLinkStore, PremiumStatus } from './schema/EasidLinkStore';
import { DialogState } from './schema/EasidLinkStore';

export const getEasidLinkStore: () => EasidLinkStore = createStore<EasidLinkStore>(
    'easidLinkStore',
    {
        entries: new Map<string, EasidResponse>(),
        premiumEntries: new Map<string, PremiumStatus>(),
        dialogState: DialogState.CLOSED,
        accountToLink: undefined,
    }
);
